import { useCallback, useEffect, useState } from 'react';
import { ScrollToTopButton } from './types';

export const useScrollToTopButton = (
  scrollableClass = 'ag-body-viewport ag-selectable ag-layout-normal ag-row-no-animation'
): ScrollToTopButton => {
  const [visible, setVisible] = useState(false);
  const scrollableClassName = document.getElementsByClassName(
    scrollableClass
  ) as HTMLCollectionOf<HTMLElement>;
  const value = scrollableClassName.length - 1;

  const handleScroll = useCallback(() => {
    if (scrollableClassName[value])
      setVisible(scrollableClassName[value].scrollTop !== 0);
  }, [scrollableClassName, value]);

  useEffect(() => {
    if (scrollableClassName[value])
      scrollableClassName[value].addEventListener('scroll', handleScroll);
    return () => {
      if (scrollableClassName[value])
        scrollableClassName[value].removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, scrollableClassName, value]);

  const handleClick = () => {
    const scrollDiv: HTMLDivElement = scrollableClassName[
      value
    ] as HTMLDivElement;

    if (scrollDiv?.scrollTo) {
      scrollDiv.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  return { visible, handleClick };
};
